<template>
    <v-row align="center">
        <v-col>
            <v-select 
                solo 
                dense 
                label="Don't send" 
                :items="reportFrecuencies" 
                item-text="label"
                item-value="value"
                :hide-details="true"
                v-model="item.report.frecuency"
                @change="update(item)" />
        </v-col>
        <v-col>
            <v-switch 
                dense 
                v-model="item.report.accumulated" 
                hide-details 
                @change="update">
                <template v-slot:label>
                    <small>Cumulative</small>
                </template>
            </v-switch>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: 'ReportControls',
    props: {
        customer: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        item: { report: {} },
        reportFrecuencies: [
            { label: 'Daily', value: 'daily' },
            { label: 'Weekly', value: 'weekly' },
            { label: 'Monthly', value: 'monthly' },
            { label: 'Don´t send', value: false }
        ]
    }),
    mounted() {
        this.item = this.customer;
    },
    methods: {
        update() {
            this.$emit('updated', this.item);
        }
    },
    watch: {
        customer(newVal) {
            this.item = newVal;
        }
    }
}
</script>


<style scoped>
.col { padding: 6px !important; }
.v-input--selection-controls { margin-top: 0; }
</style>